import type { CanadaArticle } from "@/data/canada-articles";

/**
 * Lazy per-article loader.
 *
 * Each article body lives in its own generated JSON file, so a page downloads
 * only the article it renders instead of the whole country data file.
 */
const MODULES = import.meta.glob("/src/generated/articles/*/*.json");

export type FullArticle = CanadaArticle;

export async function loadArticle(
  country: string,
  slug: string,
): Promise<FullArticle | null> {
  const key = `/src/generated/articles/${country}/${slug}.json`;
  const mod = MODULES[key];
  if (!mod) return null;
  const loaded = (await mod()) as { default: FullArticle };
  return loaded.default;
}
